import "../styles/call-back.css";
import { useState, useEffect } from "react";
import UserController from "../services/user-controller";

export default function CallBack(props) {
	const [isLoading, setIsLoading] = useState(true);
	const [order, setOrder] = useState({
		isPayed: false,
		orderNumber: "",
		trackingNumber: "",
		paymentDate: null,
		totalCost: 0,
		items: [
			{
				storeName: "",
				productName: "",
				modelName: "",
				quantity: 0,
				productPrice: 0,
				offPercent: 0,
			},
		],
	});
	const [errorMessage, setErrorMessage] = useState("");
	//
	const userController = new UserController();

	useEffect(() => {
		getData();
	}, []);

	const getData = async function () {
		try {
			if (window.isBusy === true) return;
			window.isBusy = true;
			setErrorMessage("");
			const queryParams = new URLSearchParams(
				window.location.href.split("?")[1]
			);
			var result = await userController.getOrder(
				queryParams.get("orderNumber")
			);
			if (result.isSuccess === false) throw result.message;
			setOrder(result.value);
		} catch (error) {
			setErrorMessage(error.toString());
		}
		window.isBusy = false;
		setIsLoading(false);
	};

	return (
		<article className="call-back">
			{isLoading === true && (
				<div>
					<h2>لطفا منتظر بمانید...</h2>
				</div>
			)}
			{isLoading === false && errorMessage && <p>{errorMessage}</p>}

			{isLoading === false && !errorMessage && (
				<>
					{order.isPayed === false && (
						<div className="cb-failed">
							<h2>پرداخت ناموفق</h2>
							<p>سفارش شما با شماره {order.orderNumber} پرداخت نشده است</p>
						</div>
					)}
					{order.isPayed === true && (
						<div class="cb-success">
							<h2>پرداخت موفق</h2>
							<p>سفارش شما با موفقیت پرداخت و ثبت شد</p>
							<ul>
								<li>
									<label>شماره سفارش</label>
									<i></i>
									<b>{order.orderNumber}</b>
								</li>
								<li>
									<label>شماره پیگیری</label>
									<i></i>
									<b>{order.trackingNumber}</b>
								</li>
								<li>
									<label>تاریخ پرداخت</label>
									<i></i>
									<b>
										{order.paymentDate
											?.toLocaleString("fa-IR")
											.replace(",", " ساعت ")}
									</b>
								</li>
								<li>
									<label>هزینه پرداختی</label>
									<i></i>
									<b>{order.totalCost?.toLocaleString("en-US")} ریال</b>
								</li>
							</ul>
							{order.items.map((item) => (
								<div>
									<h2>{item.storeName}</h2>
									<div class="item-info">
										<span>
											{item.productName} : {item.modelName}
										</span>
										<b>{item.quantity} عدد</b>
									</div>
									<div class="price">
										<span>{item.productPrice.toLocaleString("en-US")}</span>
										<b>با {item.offPercent} %</b>
										<strong>
											{(
												item.productPrice   -
												item.productPrice *
													item.offPercent *
													0.01
											).toLocaleString("en-US")}{" "}
											ریال
										</strong>
									</div>
								</div>
							))}
						</div>
					)}
				</>
			)}
		</article>
	);
}
